import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/other-images/logo-login.png'
import _imports_1 from '@/assets/images/other-images/dark-logo-login.png'


const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = { class: "comingsoon" }
const _hoisted_3 = { class: "comingsoon-inner text-center" }
const _hoisted_4 = {
  class: "countdown",
  id: "clock-arrival",
  "data-hours": "1",
  "data-minutes": "2",
  "data-seconds": "3"
}

import { defineAsyncComponent } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexComingsoonSimple',
  setup(__props) {

const TimerView = defineAsyncComponent(() => import("@/components/common/TimerView.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          class: "for-light",
          src: _imports_0,
          alt: ""
        }, null, -1)),
        _cache[1] || (_cache[1] = _createElementVNode("img", {
          class: "for-dark",
          src: _imports_1,
          alt: ""
        }, null, -1)),
        _cache[2] || (_cache[2] = _createElementVNode("h5", null, "WE ARE COMING SOON", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(TimerView))
        ])
      ])
    ])
  ]))
}
}

})